export default {
  ko: {
    messages: {
      required: '필수 항목',
      validFullName: '성과 이름을 입력했는지 확인하십시오.'
    },
    custom: {
      email: {
        required: '이메일 주소를 입력해주세요.',
        email: '올바른 이메일 주소를 입력해주세요.'
      },
      firstName: {
        required: '이름을 입력해주세요.'
      },
      lastName: {
        required: '성을 입력해주세요.'
      },
      dob: {
        required: '생년월일을 입력해주세요.'
      },
      fullName: {
        required: '유효한 성명을 입력하십시오.',
        validateFullName: '성과 이름을 입력했는지 확인하십시오.'
      },
      name: {
        required: '이름을 입력해주세요',
        max: (val, length) => `${length} 자 이내로 입력해주세요`,
        unicodesValidator: '이모티콘은 허용되지 않습니다.'
      },
      title: {
        required: '제목을 입력해주세요',
        max: (val, length) => `${length} 자 이내로 입력해주세요`,
        unicodesValidator: '이모티콘은 허용되지 않습니다.'
      },
      text: {
        required: '본문을 작성해주세요',
        min: (val, length) => `${length} 자 이상 입력해주세요`,
        max: (val, length) => `${length} 자 이내로 입력해주세요`,
        unicodesValidator: '이모티콘은 허용되지 않습니다.'
      },
      postalCode: {
        required: '우편 번호는 필수 요소 입니다.',
        min: function (_, min) {
          switch (I18n.siteCountryLs) {
            case 'au':
              return `유효한 우편 번호를 ${min} 자리로 입력하세요 (예 : 0200).`
            case 'nz':
              return `유효한 우편 번호를 ${min} 자리로 입력하세요 (예 : 02000).`
            case 'th':
              return `유효한 우편 번호를 ${min} 자리로 입력하세요.`
            case 'my':
              return `유효한 우편 번호를 ${min} 자리로 입력하세요 (예 : 02000).`
            case 'ph':
              return `유효한 우편 번호를 ${min} 자리로 입력하세요 (예 : 0550).`
            case 'id':
              return `유효한 우편 번호를 ${min} 자리로 입력하세요.`
            default:
              return `유효한 우편 번호를 ${min} 자리로 입력하세요.`
          }
        },
        max: function (_, max) {
          switch (I18n.siteCountryLs) {
            case 'au':
              return `유효한 우편 번호를 ${max} 자리로 입력하세요 (예 : 0200).`
            case 'nz':
              return `유효한 우편 번호를 ${max} 자리로 입력하세요 (예 : 02000).`
            case 'th':
              return `유효한 우편 번호를 ${max} 자리로 입력하세요.`
            case 'my':
              return `유효한 우편 번호를 ${max} 자리로 입력하세요 (예 : 02000).`
            case 'ph':
              return `유효한 우편 번호를 ${max} 자리로 입력하세요 (예 : 0550).`
            case 'id':
              return `유효한 우편 번호를 ${max} 자리로 입력하세요.`
            default:
              return `유효한 우편 번호를 ${max} 자리로 입력하세요.`
          }
        }
      },
      city: {
        required: '유효한 도시를 선택하십시오.'
      },
      state: {
        required: '유효한 상태를 선택하십시오.'
      },
      suburb: {
        required: '유효한 교외를 선택하십시오.'
      },
      addressOne: {
        required: '유효한 주소를 입력하십시오.',
        max: (_, max) => `주소가 ${max} 자 미만인지 확인하십시오`
      },
      district: {
        required: '유효한 지구를 선택하십시오.'
      },
      province: {
        required: '유효한 주를 선택하십시오.'
      },
      addressAndBarangay: {
        required: '유효한 주소와 바랑가이를 입력하십시오.'
      },
      contactNumber: {
        required: '유효한 연락처를 입력하십시오.',
        numeric: '숫자 만 입력했는지 확인하십시오.',
        regex: '전화 번호가 잘못되었습니다.'
      },
      mobileNumber: {
        required: '유효한 휴대폰 번호를 입력하십시오.',
        numeric: '숫자 만 입력했는지 확인하십시오.',
        validatePhoneNumber: '휴대폰 번호가 올바르지 않습니다.'
      },
      membershipId: {
        required: '멤버십 ID 번호를 입력해주세요.'
      },
      distributionConsent: {
        required: '이용약관에 동의해주세요'
      },
      nameOnCard: {
        required: '카드상의 이름을 입력해주세요',
        nameOnCardValidator: '카드상의 이름이 유효하지 않습니다'
      },
      cardNumber: {
        required: '카드 번호를 입력해주세요',
        cardNumberValidator: '카드 번호가 유효하지 않습니다',
        cardAvailability: '입력하신 카드는 지원되지 않는 카드입니다. 다른 카드를 이용해주세요.'
      },
      expiration: {
        required: '만료기간을 입력해주세요',
        expirationValidator: '만료기간이 유효하지 않습니다'
      },
      cvc: {
        required: 'cvc를 입력해주세요',
        cvcValidator: 'cvc가 유효하지 않습니다'
      },
      phoneNumberCode: {
        required: '국가 코드를 선택해주세요.',
        phoneNumberValidator: '유효한 국가 번호 또는 전화번호를 입력하세요.'
      },
      phoneNumber: {
        required: '핸드폰 번호를 입력해주세요.',
        phoneNumberValidator: '유효한 국가 번호 또는 전화번호를 입력하세요.'
      },
      selfCollectionSelection: {
        required: '계속하려면 자체 수집 옵션을 선택하십시오.'
      },
      issuers: {
        required: '유효한 지불 방법을 선택하십시오.'
      },
      collectInfo: {
        required: '필수 사항에 동의해주세요.'
      },
      discloseInfo: {
        required: '필수 사항에 동의해주세요.'
      }
    }
  }
}
